// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"0705caa8","284":"adb5c481","295":"09da7758","443":"e481da78","781":"284c2a48","947":"284c2a48"}[chunkId] + ".chunk.css";
};